// extracted by mini-css-extract-plugin
export default {"backdrop":"AddTagModal_backdrop__Al1gm","modal":"AddTagModal_modal__DApvu","slide-down":"AddTagModal_slide-down__Tw-e-"};